'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./index-fccd5f88.js');
var IconIndicator = require('./IconIndicator-d4abc040.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
var Containers = require('./Containers-776a4de4.js');
require('./Icons-46f5553f.js');
require('./Typography-8468e4cf.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".BumpSection_module_visuallyHidden__4a48a80e {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.BumpSection_module_youtubeVideo__4a48a80e {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.BumpSection_module_BumpSection__4a48a80e {\n  position: relative;\n  padding-top: 64px;\n}\n\n.BumpSection_module_BumpTop__4a48a80e {\n  position: absolute;\n  width: 248px;\n  top: -64px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n@media (max-width: 1080px) {\n  .BumpSection_module_BumpTop__4a48a80e {\n    left: 0;\n  }\n}\n.BumpSection_module_BumpTop__4a48a80e .BumpSection_module_BumpIcon__4a48a80e {\n  position: absolute;\n  top: 20px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n.BumpSection_module_BumpContent__4a48a80e {\n  padding: 80px 24px 0 24px;\n}\n@media (max-width: 1080px) {\n  .BumpSection_module_BumpContent__4a48a80e {\n    padding-left: 24px;\n  }\n}\n.BumpSection_module_BumpContent__4a48a80e.BumpSection_module_paddingBottom__4a48a80e {\n  padding: 72px 24px;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Templates/Section/BumpSection.module.scss");
var modules_7ad3d51e = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"BumpSection_module_visuallyHidden__4a48a80e","youtubeVideo":"BumpSection_module_youtubeVideo__4a48a80e","BumpSection":"BumpSection_module_BumpSection__4a48a80e","BumpTop":"BumpSection_module_BumpTop__4a48a80e","BumpIcon":"BumpSection_module_BumpIcon__4a48a80e","BumpContent":"BumpSection_module_BumpContent__4a48a80e","paddingBottom":"BumpSection_module_paddingBottom__4a48a80e"};

function BumpSection(_ref) {
  var extraClass = _ref.extraClass,
    backgroundColor = _ref.backgroundColor,
    _ref$sectionBackgroun = _ref.sectionBackgroundColor,
    sectionBackgroundColor = _ref$sectionBackgroun === void 0 ? "#ffffff" : _ref$sectionBackgroun,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    iconLabel = _ref.iconLabel,
    children = _ref.children,
    paddingBottom = _ref.paddingBottom;
  return /*#__PURE__*/React__default["default"].createElement(Containers.Section, {
    extraClass: [modules_7ad3d51e.BumpSection, extraClass].join(" "),
    noPadding: true,
    backgroundColor: sectionBackgroundColor
  }, /*#__PURE__*/React__default["default"].createElement(Containers.Container, {
    extraClass: [modules_7ad3d51e.BumpContent, paddingBottom ? modules_7ad3d51e.paddingBottom : null].join(" "),
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React__default["default"].createElement(Containers.Container, {
    extraClass: modules_7ad3d51e.BumpTop,
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: modules_7ad3d51e.Bump,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246.17 64.92"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m0,64.92c27.38,0,52.56-13.91,68.26-36.34C80.35,11.3,100.4,0,123.09,0s42.73,11.3,54.82,28.58c15.7,22.43,40.88,36.34,68.26,36.34H0Z",
    vectorEffect: "non-scaling-stroke",
    fill: backgroundColor
  })), /*#__PURE__*/React__default["default"].createElement(IconIndicator.IconIndicator, {
    extraClass: modules_7ad3d51e.BumpIcon,
    iconName: iconName,
    iconColor: iconColor,
    iconLabel: iconLabel,
    iconHSize: 72,
    iconWSize: 72
  })), children));
}
BumpSection.propTypes = {
  extraClass: index.propTypes.exports.string,
  backgroundColor: index.propTypes.exports.string,
  sectionBackgroundColor: index.propTypes.exports.string,
  iconName: index.propTypes.exports.string,
  iconColor: index.propTypes.exports.string,
  iconLabel: index.propTypes.exports.string,
  children: index.propTypes.exports.node,
  paddingBottom: index.propTypes.exports.bool
};

exports.BumpSection = BumpSection;
